const actions = {
  setInitIntHtInfo(context, payload) {
    context.commit("initHtCnInfo"); // mutation中的方法用commit回调
  },
};
export default actions;
